import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback, useEffect } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useCustomError } from 'src/utils/custom-errors.hook'
import { z } from 'zod'

export default function SendCommunicationEmailForm({ onSubmit, guestEmail, subject }: { onSubmit: (value: SendCommunicationEmailFormType) => Promise<void>; guestEmail?: string; subject?: string }) {
  const customErrorMap = useCustomError()

  z.setErrorMap(customErrorMap)

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
  } = useForm<SendCommunicationEmailFormType>({ resolver: zodResolver(sendCommunicationEmailFormSchema) })

  useEffect(() => {
    setValue('sendTo', guestEmail ?? '', { shouldDirty: false })
    setValue('subject', subject ?? '', { shouldDirty: false })
  }, [guestEmail, subject])

  const submitHandler: SubmitHandler<SendCommunicationEmailFormType> = useCallback(
    async (data: SendCommunicationEmailFormType) => {
      await onSubmit(data)
    },
    [onSubmit],
  )

  const onFormSubmit = useCallback(handleSubmit(submitHandler), [handleSubmit, submitHandler])

  return { control, errors, onFormSubmit, isDirty }
}

function getSendCommunicationEmailFormSchema() {
  return z.object({
    sendTo: z.string().email(),
    subject: z.string().min(3).default(''),
    body: z.string().min(3).default(''),
  })
}

const sendCommunicationEmailFormSchema = getSendCommunicationEmailFormSchema()
export type SendCommunicationEmailFormType = z.infer<typeof sendCommunicationEmailFormSchema>
